import { XpressForm } from "./form";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { FormInstance } from "antd";
import { APIrequest } from "../client/request";
import { APIresponse } from "../client/response";
import { Day } from "./enum";

export namespace State {
  export class APILoader {
    progressPercentange: number = 0;
    isCompleted: boolean = false;
    loading: boolean = false;
    success: boolean = false;
    error: boolean = false;
  }

  export class Modal {
    showModal?: boolean;
    title?: string;
    message?: string;
  }

  export interface UserValidation {
    response: APIresponse.ValidateUser;
    isValidated: boolean;
    token: string;
    isProcessing: boolean;
    merchantPortalDomain: string;
    ssoDomain: string;
    apiDomain: string;
    showMobileMenu: boolean;
  }
  export interface RegistrationPage {
    ResponseCode: string;
    request: APIrequest.MerchantRegistration;
    response: UserValidation;
    showAlert: boolean;
    isSuccess: boolean;
    processing: boolean;
    key: string;
  }

  export interface DashboardState {
    dashboardStatistics: APIresponse.Statistics;
    dashboardTable: APIresponse.Top10Transactions;
    response: APIresponse.ValidateUser;
    dasboardBalance: APIresponse.Balances;
    processing: boolean;
    day: string;
    showBalance: boolean;
  }
  export interface Config {
    data: APIresponse.Config;
    kyc?: APIresponse.KycType;
    logoutConfirmation: boolean;
    title: string;
    message: string;
    okText: string;
    cancelText: any;
    onOk: any;
    onCancel: any;
    cancelButtonProps: any;
  }

  export interface ManageCategory {
    response: Array<APIresponse.CategoryDTO>;
    originalResponse: Array<APIresponse.CategoryDTO>;
    processing: boolean;
    data: any;
    showTableModal: boolean;
  }

  export interface MerchantBiller {
    response: Array<APIresponse.MerchantBiller>;
    originalResponse: Array<APIresponse.MerchantBiller>;
    request: APIrequest.BillerRequest;
    allBiller: AllBillers;
    showModal: boolean;
    check: APIresponse.API;
    processing: boolean;
    data: any;
    firstName: string;
    lastName: string;
    role: any;
    key: string;
    Billerdetails: APIresponse.MerchantBiller;
    showTableModal: boolean;
    excludedBillers: Array<APIresponse.ExcludedBiller>;
  }

  export interface AllBillers {
    responses: Array<APIresponse.AllBillerResponse>;
    AllBillerDetails: APIresponse.AllBillerResponse;
  }

  export interface MerchantProduct {
    response: Array<APIresponse.MerchantProducts>;
    originalResponse: Array<APIresponse.MerchantProducts>;
    processing: boolean;
    data: any;
    showTableModal: boolean;
    filterRequests: APIrequest.FilterProductRequest;
    isDownload: boolean;
    page: any;
    pageSize: any;
    total: any;
  }
  export interface MerchantCommission {
    response: Array<APIresponse.MerchantCommission>;
    originalResponse: Array<APIresponse.MerchantCommission>;
    processing: boolean;
    data: any;
    showTableModal: boolean;
  }

  export interface MerchantPermissions {
    response: Array<APIresponse.Permission>;
    data: any;
    roleId: string;
    showTableModal: boolean;
  }
  export interface MerchantRole {
    response: Array<APIresponse.Role>;
    originalResponse: Array<APIresponse.Role>;
    roleDetails: APIresponse.Role;
    request: APIrequest.CreateRoleRequest;
    showAlert: boolean;
    showPermissionModal: boolean;
    isSuccess: boolean;
    processing: boolean;
    data: any;
    isUpdate: boolean;
    permissions: MerchantPermissions;
    action: "edit" | "delete" | "create";
    showModal: boolean;
    showTableModal: boolean;
  }
  export interface MerchantUsers {
    response: Array<APIresponse.MerchantUser>;
    originalResponse: Array<APIresponse.MerchantUser>;
    data: any;
    processing: boolean;
    action: "edit" | "active" | "create";
    request: APIrequest.CreateMerchantUser;
    showAlert: boolean;
    isSuccess: boolean;
    isUpdate: boolean;
    userDetails: APIresponse.MerchantUser;
    isLoggedIn: boolean;
    role: MerchantRole;
    showMoreUserInfo: boolean;
    showModal: boolean;
    showTableModal: boolean;
  }
  export interface MerchantDashboardBalance {
    response: APIresponse.Balances;
    processing: boolean;
    request: APIrequest.Dashboard;
    key: string;
    value: any;
  }
  export interface MerchantDashboardTop10 {
    response: APIresponse.Top10Transactions;
    key: string;
  }
  export interface MerchantDashboardStatistics {
    response: APIresponse.Statistics;
    request: APIrequest.Dashboard;
    day: string;
    key: string;
  }
  export interface MerchantSettings {
    response: APIresponse.Settings;
    action: "keys" | "reset";
    processing: boolean;
    merchantUser: Array<APIresponse.MerchantUser>;
    request: APIrequest.walletAlert;
    walletAlert: APIresponse.WalletAlertResponse;
    changePin: APIrequest.ChangeTransactionPin;
  }

  export interface MerchantReports {
    response: Array<APIresponse.Report>;
    originalResponse: Array<APIresponse.Report>;
    merchantSettlements: Array<APIresponse.MerchantSettlements>;
    originalMerchantSettlements: Array<APIresponse.MerchantSettlements>;
    processing: boolean;
    filterRequest: APIrequest.ReportSearch;
    filterSettlementRequest: APIrequest.SettlementSearch;
    isDownload: boolean;
    data: any;
    total: any;
    settlementTotal: any;
    all?: APIresponse.Report;
    showModal: boolean;
    showTableModal: boolean;
    page: number;
    showReceipt: boolean;
    requestId: any;
    transactionDate: any;
    receipt: any;
    isSuccessful: boolean;
    user: APIresponse.ValidateUser;
    lookUpResponse: APIresponse.LookUpResponse;
    title: string;
    message: any;
    billerName?: string;
    date?: string;
  }

  export interface Wallet {
    merchantWalletCommission: APIresponse.WalletCommission;
    originalResponse: Array<APIresponse.WalletTransactionDTO>;
    walletcommissionOriginalResponse: Array<APIresponse.CommissionTransactionDTO>;
    merchantWalletTransaction: APIresponse.WalletTransaction;
    TransferCommission: APIresponse.CommissionTransfer;
    merchantDashboard: APIresponse.Balances;
    details: APIresponse.CommissionTransactionDTO;
    showModal: boolean;
    show: APIresponse.WalletTransactionDTO;
    showWalletModal: boolean;
    showWalletCommissionModal: boolean;
    processing: boolean;
    isDownload: boolean;
    filterRequest: APIrequest.WalletSearch;
    showMore: boolean;
    showTableModal: boolean;
  }

  export interface MerchantAuditLogs {
    response: Array<APIresponse.AuditLog>;
    originalResponse: Array<APIresponse.AuditLog>;
    processing: boolean;
    filterRequests: APIrequest.AuditLogSearch;
    isDownload: boolean;
    showTableModal: boolean;
  }

  export interface KycTier {
    response: Array<APIresponse.KYCTiers>;
    processing: boolean;
  }

  export interface MerchantProfile {
    kycTier: KycTier;
    current: number;
    status: string;
    form: FormInstance<any>;
    request: APIrequest.UpdateMerchantProfile;
    response: APIresponse.MerchantProfile;
    isFinished: boolean;
    saveAlert: boolean;
    showAlert: boolean;
    details: APIresponse.ValidateUser;
    UploadKycRequest: APIrequest.KycFormRequest;
    file: File;
    fileList: KycFileList;
    processing: boolean;
    profilePage: any;
    unlockKycDropDown: boolean;
  }

  export class FileList {
    uid?: string;
    name?: string;
    status?: "done";
    url?: string;
    thumbUrl?: string;
  }

  export class KycFileList {
    boardResolutionApproval?: FileList[];
    cac2AndCac7?: FileList[];
    memart?: FileList[];
    directorValidIdCard?: FileList[];
    gazette?: FileList[];
    governmentIssuedIdCard?: FileList[];
    utilityBill?: FileList[];
    certificateOfIncorporation?: FileList[];
  }

  export interface MerchantTransaction {
    response?: Array<APIresponse.TransactionCategory>;
    originalResponse: Array<APIresponse.TransactionCategory>;
    categoryResponse: APIresponse.TransactionCategory;
    processing: boolean;
    showBillers: boolean;
    serviceCode?: string;
    referenceId?: string;
    account?: string;
    accountNumber?: string;
    phoneNumber?: string;
    categoryId: number;
    billerId: number;
    productDetails: APIresponse.TransactionProduct;
    biller: Array<APIresponse.TransactionBiller>;
    originalBiller: Array<APIresponse.TransactionBiller>;
    showTransactionForm: boolean;
    showAirtimeForm: boolean;
    product: Array<APIresponse.TransactionProduct>;
    originalProduct: Array<APIresponse.TransactionProduct>;
    billerDetails: APIresponse.TransactionBiller;
    details: APIrequest.Details;
    user: APIresponse.ValidateUser;
    productPaymentCategory: string;
    requestId: any;
    uniqueCode: string;
    title: string;
    message: string;
    isSuccessful: boolean;
    isPending?: boolean;
    showResult: boolean;
    categoryDetails: APIresponse.TransactionCategory;
    showTransactionPinForm: boolean;
    showTransactionInfo: boolean;
    transactionPin: APIrequest.TransactionPin;
    pinCorrect: boolean;
    billerLoaded: boolean;
    isCreatePin: boolean;
    createPin: APIrequest.CreateTransactionPin;
    pinCreation: boolean;
    electricity: boolean;
    showProduct: boolean;
    form: XpressForm;
    productAmount: any;
    lookUpResponse: APIresponse.LookUpResponse;
    showElectricityLookUp: boolean;
    showReceipt: boolean;
    receipt: any;
    transactionDate: any;
    educationProductOption: string;
    CableTvProductOption: string;
    showEducationPayment: boolean;
    isLookUp: boolean;
    showCableTvLookUp: boolean;
    showBettingLookUp: boolean;
    modalWidth: string;
    singleProducts: any;
  }

  export interface BulkAirtime {
    response: Array<APIresponse.AllBulkAirtime>;
    originalResponse: Array<APIresponse.AllBulkAirtime>;
    singleAirtimeBulk: Array<APIresponse.BulkAirtime>;
    showSingleBulk: boolean;
    showBulkAirtimeTransaction: boolean;
    request: APIrequest.BulkUpload;
    formData: any;
    bulkId: any;
    page: number;
    pageSize: number;
    processing: boolean;
    record: APIresponse.AllBulkAirtime;
  }
}
